// eslint-disable-next-line jira/import-whitelist
import issueViewDevSummaryDataQuery, {
	type issueViewDevPanelSummaryDataQuery,
} from '@jira/issue__dev-panel-data-query/src/__generated__/issueViewDevPanelSummaryDataQuery.graphql.ts';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const issueViewDevPanelDataResource: RouteResource<
	PreloadedQuery<issueViewDevPanelSummaryDataQuery, Record<string, unknown>>
> = createRelayResource<issueViewDevPanelSummaryDataQuery>({
	type: 'ISSUE_VIEW_DEV_PANEL_SUMMARY_DATA',
	getQuery: ({ match, query }, { tenantContext }) => {
		const issueKey = getIssueKey(match) || query?.selectedIssue || '';

		if (!issueKey) {
			return {
				parameters: issueViewDevSummaryDataQuery,
				variables: {
					issueKey: '',
					cloudId: '',
				},
				options: { fetchPolicy: 'store-only' },
			};
		}

		return {
			parameters: issueViewDevSummaryDataQuery,
			variables: {
				issueKey,
				cloudId: tenantContext?.cloudId,
			},
			options: { fetchPolicy: 'store-or-network' },
		};
	},
	isBrowserOnly: true,
});
